import { useState, useEffect } from "react";
import agenda from "../images/icons/icon-user-agenda-white.svg";
import { login_request } from "../utils/api/login.js";
import { useCookies } from "react-cookie";

export function Login({ setUser, changeSection }) {
  const handleLogin = async () => {
    if(username && password) {
      const response = await login_request(username, password);
      if(response.data){
        setUser(response.data);

        setCookie("session", response.data, { path: "/" });
        setUsernameCookie("username", username, { path: "/" });
        changeSection("search");
      }else{
        alert("Usuario o contraseña incorrectos");
      }
    }else {
      alert("Introduce un usuario y contraseña");
    }
  };

  const handleRegister = () => {
    changeSection("register");
  }

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();

  const [cookies, setCookie, removeCookie] = useCookies(["session"]);
  const [usernameCookies, setUsernameCookie, removeUsernameCookie] = useCookies(["username"]);

  const handleNameChange = (event) => {
    setUsername(event.target.value);
  }
  const handlePasswordChange = (event) => { 
    setPassword(event.target.value);
  }
  return (
    <>
    <div className="p-login ">
      <div className="total content-section a-bg a-bg--fixed login-bg" >
        <div className="container">
          <div className="m-layLogin">
            <div className="col">
              <div className="m-iconTit">
                <img src={agenda} alt="logo-primary"  className="icon"/>
                <span className="tit">Accede a tu cuenta</span>
              </div>
              <div className="m-bxFormSpecial">
                <div className="bx paddLog">

                  <div className="m-frmGroup ">
                    <label>Nombre de usuario</label>
                    <input className="data-input" 
                           placeholder="Nombre de usuario" 
                           name="user_name" 
                           value={username}
                           onChange={handleNameChange}/>
                  
                  </div>
                  <div className="m-frmGroup">
                    <label >Contraseña</label>
                    <input className="data-input" 
                           placeholder="Contraseña" 
                           name="password" 
                           value={password}
                           onChange={handlePasswordChange}/>
                    
                  </div>
                  
                  <br/>
                  <div className="m-frmGroup">
                    <div className="btnBlue-l" id="login-button"  onClick={() => handleLogin()}  >Accede </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="col">
              <div className="m-bxRegisterPill">
                <div className="bx paddLog">
                  <svg xmlns="http://www.w3.org/2000/svg" width="67.611" height="67.503" viewBox="0 0 67.611 67.503" className="icon">
                    <g transform="translate(2578.741 1925.967)">
                      <path d="M-2521.032-1916.066a33.584,33.584,0,0,0-23.9-9.9,33.587,33.587,0,0,0-23.9,9.9,33.586,33.586,0,0,0-9.9,23.9,33.584,33.584,0,0,0,9.9,23.9q.563.563,1.147,1.094a59.869,59.869,0,0,0,6.741-11.925,64.263,64.263,0,0,0,4.517-17.313.957.957,0,0,0-.58-1.023.856.856,0,0,0-1.043.276c-1.643,2.433-2.282,4.7-3.711,7.076-2.583,4.3-5.227,8.083-9.432,10.594a29,29,0,0,1-2.905-12.683,29.2,29.2,0,0,1,29.17-29.169,29.2,29.2,0,0,1,29.169,29.169,28.989,28.989,0,0,1-2.905,12.683c-4.205-2.511-6.849-6.293-9.432-10.594-1.429-2.38-2.068-4.643-3.71-7.076a.856.856,0,0,0-1.043-.276.957.957,0,0,0-.58,1.023,64.317,64.317,0,0,0,4.516,17.313,59.9,59.9,0,0,0,6.742,11.925q.584-.533,1.147-1.094a33.585,33.585,0,0,0,9.9-23.9A33.587,33.587,0,0,0-2521.032-1916.066Z" transform="translate(0)" fill="#8ec5e5"></path>
                      <path d="M-2531.471-1895.839a2.284,2.284,0,0,0-.282-1.108,1.593,1.593,0,0,0-1.4-.617,1.614,1.614,0,0,0-.774.2,1.5,1.5,0,0,0-.7,1.424l-.149,42.307a33.471,33.471,0,0,0,15.813-5.4,65.246,65.246,0,0,1-7.447-13.131A68.964,68.964,0,0,1-2531.471-1895.839Z" transform="translate(-7.473 -4.827)" fill="#8ec5e5"></path>
                      <path d="M-2545.34-1897.368a1.616,1.616,0,0,0-.775-.2,1.6,1.6,0,0,0-1.4.617,2.3,2.3,0,0,0-.282,1.108,68.976,68.976,0,0,1-5.065,23.675,65.28,65.28,0,0,1-7.446,13.131,33.472,33.472,0,0,0,15.812,5.4l-.149-42.307A1.5,1.5,0,0,0-2545.34-1897.368Z" transform="translate(-3.133 -4.827)" fill="#8ec5e5"></path>
                    </g>
                  </svg>
                  <p className="tit">¿Aún no tienes cuenta?</p>
                  <p className="subtit">Registrate en unos sencillos pasos y podrás comprar billetes de ferry al mejor precio.</p>
                  <div className="btnOrange-l btnArrow-l btn" id="login-button"  onClick={() => handleRegister()}  >Registrate </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}